import { axiosClient } from '../api/proxy/AxiosClient';

const base = '/bot/campaigns/me';

export const CampaignApi = {
  list: () => axiosClient.get(base).then((r) => r.data),
  create: (name) => axiosClient.post(base, { name }).then((r) => r.data),
  get: (id) => axiosClient.get(`${base}/${id}`).then((r) => r.data),
  rename: (id, name) =>
    axiosClient.patch(`${base}/${id}`, { name }).then((r) => r.data),
  remove: (id) => axiosClient.delete(`${base}/${id}`),
  markReady: (id) => axiosClient.post(`${base}/${id}/ready`).then((r) => r.data),
  clearReady: (id) =>
    axiosClient.post(`${base}/${id}/clear-ready`).then((r) => r.data),
  deactivate: (id) =>
    axiosClient.post(`${base}/${id}/deactivate`).then((r) => r.data),
  createUseCase: (campaignId, body) =>
    axiosClient.post(`${base}/${campaignId}/use-cases`, body).then((r) => r.data),
  deleteUseCase: (campaignId, useCaseId) =>
    axiosClient.delete(`${base}/${campaignId}/use-cases/${useCaseId}`),
  listFiles: () => axiosClient.get(`${base}/files`).then((r) => r.data),
  uploadFile: (file) => {
    const form = new FormData();
    form.append('file', file);
    return axiosClient
      .post(`${base}/files`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
};
